class ListenerHolder{
    constructor(target, name, callback){
      this.target = target
      this.name=name
      this.callback=callback
    }
}

export default ListenerHolder